import React, { useEffect } from 'react';
import { actionCreators } from './action';
import { connect } from 'react-redux';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Link } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Dropable from '../Dropable';


const useStyles = makeStyles(theme => ({
  listItemText: {
    textOverflow: 'ellipsis',
    whiteSpace: 'pre-wrap'
  },
}));


 function ProjectsList(props) {
const classes = useStyles();


  return (
    <List component="div" disablePadding>
        {props.projects && props.projects.map((project)=> 
        <Link to={`/project/${project.id}`}> 
         {props.isOpenDrawer && 
         <Dropable projectId={project.id}>
          <ListItem button className={props.classes.nested}>
           <span style={{padding: "5px", fontSize: "20px"}}>•</span>
          <ListItemText primary={project.title} className={classes.listItemText} />
          </ListItem>
        </Dropable>}
        </Link>)}
      </List>
  );
}


const mapStateToProps = (state, props) => {
    
    function isProject(idTask) {
      const task = state.tasks[idTask];
      return task.project === true;
    }

    function isOpen(idTask) {
      const task = state.tasks[idTask];
      return task.done === false;
    }
  
    const projects = state.tasks && Object.keys(state.tasks)
      .filter(isProject)
      .filter(isOpen)
      .map(key => state.tasks[key]);
  
    return {
      projects: projects,
      isOpenDrawer: state.isOpenDrawer
    };
  };

export default connect(
  mapStateToProps,
  actionCreators
)(ProjectsList)